module.exports = __webpack_public_path__ + "img/116ne.c6933f03.svg";